import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function BonusPricingSection() {
  return <section id="compra" className="py-10 md:py-14 px-4 bg-white text-center scroll-mt-10" data-id="element-9">
      <div className="max-w-3xl mx-auto" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-11">
          {/* BONUSES */}
          <div className="mb-10" data-id="element-12">
            <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-2" data-id="element-13">
              🎁 BONOS EXCLUSIVOS
            </h2>
            <p className="text-xl font-bold text-red-600 mb-8 bg-red-50 inline-block px-6 py-1.5 rounded-full" data-id="element-14">
              Gratis por el día de hoy
            </p>

            <div className="space-y-8" data-id="element-15">
              {/* Bono 1 */}
              <div className="bg-gray-50 rounded-3xl p-6 border border-gray-200 shadow-lg flex flex-col md:flex-row items-center gap-6 text-left" data-id="element-16">
                <a href="#compra" className="w-full md:w-1/2 flex justify-center cursor-pointer hover:scale-105 transition-transform" data-id="element-17">
                  <img src="https://cdn.magicpatterns.com/uploads/1UYpxoJd9aP7LmDuavadk9/bono_1.png" alt="Bono 1" className="w-full max-w-[400px] drop-shadow-xl rounded-xl" data-id="element-18" />
                </a>
                <div className="w-full md:w-1/2" data-id="element-19">
                  <h3 className="text-xl font-black text-yellow-600 mb-1" data-id="element-20">
                    🎁 Bono #1
                  </h3>
                  <h4 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-21">
                    Sistema de planificación semanal
                  </h4>
                  <p className="text-base text-gray-600 mb-3" data-id="element-22">
                    Organiza tus comidas fácilmente y evita improvisar.
                  </p>
                  <div className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm inline-block" data-id="element-23">
                    <p className="text-sm text-gray-500 line-through" data-id="element-24">
                      Valor: €19
                    </p>
                    <p className="text-xl font-black text-green-600" data-id="element-25">
                      HOY: GRATIS
                    </p>
                  </div>
                </div>
              </div>

              {/* Bono 2 */}
              <div className="bg-gray-50 rounded-3xl p-6 border border-gray-200 shadow-lg flex flex-col md:flex-row-reverse items-center gap-6 text-left" data-id="element-26">
                <a href="#compra" className="w-full md:w-1/2 flex justify-center cursor-pointer hover:scale-105 transition-transform" data-id="element-27">
                  <img src="https://cdn.magicpatterns.com/uploads/sGfwGSRwdQMyTV1UHQS6bY/bono_2.png" alt="Bono 2" className="w-full max-w-[400px] drop-shadow-xl rounded-xl" data-id="element-28" />
                </a>
                <div className="w-full md:w-1/2" data-id="element-29">
                  <h3 className="text-xl font-black text-yellow-600 mb-1" data-id="element-30">
                    🎁 Bono #2
                  </h3>
                  <h4 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-31">
                    Guía completa de cocción en Airfryer
                  </h4>
                  <p className="text-base text-gray-600 mb-2" data-id="element-32">Incluye:</p>
                  <ul className="space-y-1 text-base text-gray-700 font-medium mb-3" data-id="element-33">
                    <li className="flex items-center" data-id="element-34">
                      <span className="text-green-500 mr-2" data-id="element-35">✔</span> tabla de
                      tiempos
                    </li>
                    <li className="flex items-center" data-id="element-36">
                      <span className="text-green-500 mr-2" data-id="element-37">✔</span>{' '}
                      temperaturas correctas
                    </li>
                    <li className="flex items-center" data-id="element-38">
                      <span className="text-green-500 mr-2" data-id="element-39">✔</span> trucos de
                      cocción
                    </li>
                  </ul>
                  <div className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm inline-block" data-id="element-40">
                    <p className="text-sm text-gray-500 line-through" data-id="element-41">
                      Valor: €15
                    </p>
                    <p className="text-xl font-black text-green-600" data-id="element-42">
                      HOY: GRATIS
                    </p>
                  </div>
                </div>
              </div>

              {/* Bono 3 */}
              <div className="bg-gray-50 rounded-3xl p-6 border border-gray-200 shadow-lg flex flex-col md:flex-row items-center gap-6 text-left" data-id="element-43">
                <a href="#compra" className="w-full md:w-1/2 flex justify-center cursor-pointer hover:scale-105 transition-transform" data-id="element-44">
                  <img src="https://cdn.magicpatterns.com/uploads/jMugWF6hu78dbiNaCWcBRa/bono_3.png" alt="Bono 3" className="w-full max-w-[400px] drop-shadow-xl rounded-xl" data-id="element-45" />
                </a>
                <div className="w-full md:w-1/2" data-id="element-46">
                  <h3 className="text-xl font-black text-yellow-600 mb-1" data-id="element-47">
                    🎁 Bono #3
                  </h3>
                  <h4 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-48">
                    Lista de compra saludable mensual
                  </h4>
                  <p className="text-base text-gray-600 mb-2" data-id="element-49">Incluye:</p>
                  <ul className="space-y-1 text-base text-gray-700 font-medium mb-3" data-id="element-50">
                    <li className="flex items-center" data-id="element-51">
                      <span className="text-green-500 mr-2" data-id="element-52">✔</span> lista
                      semanal
                    </li>
                    <li className="flex items-center" data-id="element-53">
                      <span className="text-green-500 mr-2" data-id="element-54">✔</span> lista
                      mensual
                    </li>
                    <li className="flex items-center" data-id="element-55">
                      <span className="text-green-500 mr-2" data-id="element-56">✔</span>{' '}
                      presupuesto estimado en España
                    </li>
                  </ul>
                  <div className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm inline-block" data-id="element-57">
                    <p className="text-sm text-gray-500 line-through" data-id="element-58">
                      Valor: €12
                    </p>
                    <p className="text-xl font-black text-green-600" data-id="element-59">
                      HOY: GRATIS
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* PRICING BOX */}
          <div className="bg-white rounded-3xl border-4 border-yellow-400 shadow-[0_10px_40px_rgba(0,0,0,0.1)] p-6 md:p-10 relative mt-10" data-id="element-60">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-yellow-900 font-black px-8 py-1.5 rounded-full text-lg shadow-md whitespace-nowrap" data-id="element-61">
              💰 OFERTA ESPECIAL
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4 mt-3" data-id="element-62">
              📦 Lo que recibirás hoy
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-left max-w-xl mx-auto mb-6 text-base font-medium text-gray-700 bg-gray-50 p-4 rounded-2xl border border-gray-100" data-id="element-63">
              <div className="flex items-center" data-id="element-64">
                <span className="text-green-500 mr-2" data-id="element-65">✔</span> 6 tomos del
                método
              </div>
              <div className="flex items-center" data-id="element-66">
                <span className="text-green-500 mr-2" data-id="element-67">✔</span> 3 bonos
                exclusivos
              </div>
              <div className="flex items-center" data-id="element-68">
                <span className="text-green-500 mr-2" data-id="element-69">✔</span> más de 50
                recetas saludables
              </div>
              <div className="flex items-center" data-id="element-70">
                <span className="text-green-500 mr-2" data-id="element-71">✔</span> planificación
                semanal
              </div>
              <div className="flex items-center" data-id="element-72">
                <span className="text-green-500 mr-2" data-id="element-73">✔</span> listas de compra
              </div>
              <div className="flex items-center" data-id="element-74">
                <span className="text-green-500 mr-2" data-id="element-75">✔</span> acceso inmediato
              </div>
            </div>

            <div className="mb-5" data-id="element-76">
              <p className="text-xl text-gray-500 font-bold mb-1" data-id="element-77">
                Precio regular:{' '}
                <span className="line-through text-red-500" data-id="element-78">€49,99</span>
              </p>
              <p className="text-xl font-black text-red-600 mb-1 animate-pulse" data-id="element-79">
                🔥 HOY SOLO
              </p>
              <p className="text-7xl md:text-8xl font-black text-green-600 drop-shadow-md" data-id="element-80">
                €13,99
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-3 text-sm font-bold text-gray-600 mb-6" data-id="element-81">
              <span className="flex items-center bg-gray-100 px-3 py-1 rounded-full" data-id="element-82">
                <span className="text-green-500 mr-1" data-id="element-83">✔</span> acceso inmediato
              </span>
              <span className="flex items-center bg-gray-100 px-3 py-1 rounded-full" data-id="element-84">
                <span className="text-green-500 mr-1" data-id="element-85">✔</span> descarga digital
              </span>
              <span className="flex items-center bg-gray-100 px-3 py-1 rounded-full" data-id="element-86">
                <span className="text-green-500 mr-1" data-id="element-87">✔</span> acceso de por
                vida
              </span>
              <span className="flex items-center bg-gray-100 px-3 py-1 rounded-full" data-id="element-88">
                <span className="text-green-500 mr-1" data-id="element-89">✔</span> un solo pago
              </span>
            </div>

            <CTAButton href="https://pagos.digipromarket.com/cart/53235058770261:1" text="👉 QUIERO EL MEGAPACK AHORA" className="text-2xl md:text-3xl py-6" data-id="element-90" />
          </div>

          {/* GUARANTEE */}
          <div className="mt-8 max-w-2xl mx-auto" data-id="element-91">
            <div className="flex justify-center mb-3" data-id="element-92">
              <span className="text-5xl" data-id="element-93">🛡️</span>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-94">
              Garantía sin riesgo
            </h3>
            <p className="text-lg text-gray-700 mb-1 font-medium" data-id="element-95">
              Prueba el sistema durante 7 días.
            </p>
            <p className="text-base text-gray-600 mb-2" data-id="element-96">
              Si no te ayuda a cocinar más saludable y organizar tu
              alimentación, puedes solicitar la devolución completa.
            </p>
            <p className="text-lg font-bold text-gray-900" data-id="element-97">Sin preguntas.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}